import type { User as GraftcodeUser } from '@graft/nuget-gc.webportals.users'

import type { User } from '../types/user.type'
import { decodeJwtPayload } from '../utils/decode-jwt-payload'

export async function userToObject(entity: GraftcodeUser): Promise<User> {
  const [id, emailHash, lastUserRegionIdentityUid] = await Promise.all([
    entity.get_userId(),
    entity.get_emailHash(),
    entity.get_lastUserRegionIdentityUid(),
  ])
  return {
    id,
    emailHash: emailHash,
    graftcodeUid: lastUserRegionIdentityUid.toString(),
  }
}

export async function userToObjectFromToken(token: string): Promise<User | null> {
  const decodedToken = decodeJwtPayload(token)
  return {
    id: decodedToken?.sub ?? '',
    emailHash: decodedToken?.email_hash,
    graftcodeUid: decodedToken?.graftcode_uid,
  }
}
